module.exports = __webpack_public_path__ + "img/red_073.18b21597.png";